import { render, staticRenderFns } from "./LocationContent.vue?vue&type=template&id=99373a42"
import script from "./LocationContent.vue?vue&type=script&lang=js"
export * from "./LocationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports